import React from 'react';
import './VideoSection.css';

const VideoSection = () => {
  const handleOpenVideo = () => {
    window.open('https://www.youtube.com/watch?v=UQDQagibWZ4', '_blank', 'noopener,noreferrer');
  };
  return (
    <section className="video-section" id="video-section">
      <div className="video-section-container">
        <div className="video-section-header">
          <h2 className="video-section-title">제품 구동 영상</h2>
          <p className="video-section-subtitle">태봉산업기술의 열교환기가 실제로 작동하는 모습을 확인해보세요</p>
        </div>
        <div className="video-container">
          <div 
            className="video-placeholder"
            onClick={handleOpenVideo}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') handleOpenVideo();
            }}
          >
            <img src="/video.png" alt="제품 구동 영상" className="video-image" />
            <div className="play-button">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="5,3 19,12 5,21"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
